import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/views/Home.vue';
import About from '@/views/About.vue';
import Error from '@/views/Error.vue';
import CompetitionsHome from '@/views/competitions/Home.vue';
import PreviewHome from '@/views/previews/Home.vue';
Vue.use(Router);
export default new Router({
    routes: [
        { path: '/', name: 'home', component: Home, meta: { title: 'Home' } },
        { path: '/about', name: 'about', component: About, meta: { title: 'About' } },
        { path: '/error', name: 'error', component: Error, meta: { title: 'Error' } },
        { path: '/competitions/:key?', name: 'competitionsHome', component: CompetitionsHome,
            meta: { title: 'Demo' } },
        { path: '/preview/:companyKey?/:previewKey?', name: 'previewHome', component: PreviewHome,
            meta: { title: 'Demo' } },
    ],
    mode: 'history',
});
//# sourceMappingURL=router.js.map